import React, { createContext, useContext, useState, useCallback } from 'react';

const CartContext = createContext();

export const useCart = () => useContext(CartContext);

export const CartProvider = ({ children }) => {
  const [cart, setCart] = useState([]);

  const addToCart = useCallback((product, qty = 1) => {
    setCart(prev => {
      const existing = prev.find(c => c.id === product.id);
      if (existing) {
        return prev.map(c => c.id === product.id ? { ...c, qty: c.qty + qty, ...(product.optionQtys ? { optionQtys: product.optionQtys } : {}), ...(product.memo ? { memo: product.memo } : {}) } : c);
      }
      return [...prev, {
        id: product.id,
        name: product.name,
        image: product.image,
        category: product.category,
        qty,
        ...(product.optionQtys ? { optionQtys: product.optionQtys } : {}),
        ...(product.memo ? { memo: product.memo } : {}),
      }];
    });
  }, []);

  const removeFromCart = useCallback((productId) => {
    setCart(prev => prev.filter(c => c.id !== productId));
  }, []);

  const updateQty = useCallback((productId, qty) => {
    if (qty < 1) { removeFromCart(productId); return; }
    setCart(prev => prev.map(c => c.id === productId ? { ...c, qty } : c));
  }, [removeFromCart]);

  const updateOptionQty = useCallback((productId, optionVal, delta) => {
    setCart(prev => prev.map(c => {
      if (c.id !== productId || !c.optionQtys) return c;
      const copy = { ...c.optionQtys };
      const next = (copy[optionVal] || 0) + delta;
      if (next <= 0) delete copy[optionVal];
      else copy[optionVal] = next;
      // 옵션이 모두 삭제되면 상품 자체 제거
      if (Object.keys(copy).length === 0) return null;
      const totalQty = Object.values(copy).reduce((s, v) => s + v, 0);
      return { ...c, optionQtys: copy, qty: totalQty };
    }).filter(Boolean));
  }, []);

  const clearCart = useCallback(() => setCart([]), []);

  const cartCount = cart.length;

  return (
    <CartContext.Provider value={{ cart, cartCount, addToCart, removeFromCart, updateQty, updateOptionQty, clearCart }}>
      {children}
    </CartContext.Provider>
  );
};
